import {certificateElementType} from "~/enums/certificateElementType";
import DynamicModeCertificateElement from "./dynamicCertificateElement";


export default class PageBreakCertificateElement extends DynamicModeCertificateElement {
  type: certificateElementType = certificateElementType.PageBreak
}